export const CATEGORIES = [
  {
    id: "tops",
    name: "Tops",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/image-6.webp?raw=true&w=600&h=800&fit=cropx",
  },
  {
    id: "pants",
    name: "Pants",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/whitepants.webp?raw=true&w=600&h=800&fit=crop",
  },
  {
    id: "dresses",
    name: "Dresses",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/image-7.webp?raw=true&w=600&h=800&fit=crop",
  },
  {
    id: "2_piece",
    name: "2 Piece Sets",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/image-2.webp?raw=true&w=600&h=800&fit=crop",
  },
  {
    id: "coats",
    name: "Coats",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/image-0.webp?raw=true&raw=true&w=600&h=800&fit=crop",
  },
  {
    id: "skirts",
    name: "Skirts",
    img: "https://github.com/joanrunyiri/jojos_catalogue/blob/main/Generated%20Image%20July%2016,%202026%20-%202_16AM.webp?raw=true&w=600&h=800&fit=crop",
  },
];
